"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redditSearchComments = exports.redditSearchCommentsResultSchema = exports.redditSearchCommentSchema = exports.redditSearchCommentsArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Argument schema
exports.redditSearchCommentsArgsSchema = zod_1.z.object({
    postId: zod_1.z.string().describe('The Reddit post ID to fetch comments for'),
    maxResults: zod_1.z.number().default(10).describe('required: Maximum number of comments to fetch'),
    emitMode: common_1.emitModeSchema.default('multi').describe('Emit mode for the tool. Default to "multi".'),
});
// Comment schema (recursive)
exports.redditSearchCommentSchema = zod_1.z.object({
    body: zod_1.z.string(),
    author: zod_1.z.string(),
    created_utc: zod_1.z.number(),
    score: zod_1.z.number(),
    replies: zod_1.z.array(zod_1.z.lazy(function () { return exports.redditSearchCommentSchema; })),
});
// Result schema
exports.redditSearchCommentsResultSchema = zod_1.z.array(exports.redditSearchCommentSchema);
// Tool definition
exports.redditSearchComments = (0, common_1.createEmitModeToolMetadata)({
    id: 'redditSearchComments',
    displayName: 'Reddit Fetch Comments',
    displayDescription: 'Fetch comments from a Reddit post',
    category: 'social',
    color: common_1.BRAND_COLORS.REDDIT,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.REDDIT),
    icon: 'reddit',
    argsSchema: exports.redditSearchCommentsArgsSchema,
}, exports.redditSearchCommentsResultSchema);
